// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1h12w","upload":"Small_upload__3xQV1","imageWrap":"Small_imageWrap__sLFHm","removeBtn":"Small_removeBtn__30-v6"};